import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from "../../Styles/ComponentStyles/MainPages/Register.module.scss"
import globalStyles from "../../Styles/global.module.scss"
import 'react-phone-input-2/lib/style.css'

import Grid from '@mui/material/Grid2';
import { Checkbox, Divider, FormControlLabel, FormGroup, FormLabel, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import GlobalTextfield from '../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import GlobalSymbols from '../../Utils/Layout/GlobalSymbols/GlobalSymbols';

import logo from "../../Assets/Logos/login-mac-logo.png"
import GlobalAutocomplate from '../../Utils/Layout/GlobalAutocomplate/GlobalAutoComplate';
import ReCAPTCHA from "react-google-recaptcha";
import GlobalButton from '../../Utils/Layout/GlobalButton/GlobalButton';
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';
import { MacSsoVerifyUserPayloadModel, StateOptionsInterface, UserRegistrationPayloadModel } from '../../models/axiosModels';
// import { stateOptions } from '../../Utils/Constant/UserDetailsConstant';
import { useSnackbar } from '../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import { Visibility, VisibilityOff, ArrowBack } from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useIsBelow1200 } from '../../Utils/Constant/Constant';
import ellipsis from "../../Assets/General/Ellipse.png"
import agent from '../../Services/api';
import PhoneInput from 'react-phone-input-2';
import GlobalPhoneInput from '../../Utils/Layout/GlobalPhoneInput/GlobalPhoneInput';
import useStateOptions from '../../Utils/Hooks/useStateOptions';
import { RegisteredSitesResponse } from '../../models/userDetailsModel';
import { DashboardContext, DashboardDetailPayload } from '../../Context/DashboardDetailContext';



const Registration = () => {

    const videoUrl = "https://player.vimeo.com/video/138115423?title=0&byline=0&portrait=0&controls=1";
    const {
        registerUserProfileDetails,
        setRegisterUserProfileDetails,
        userRegistrationDetails,
        setFlagLoader,
        setUserProfileDetails,
        userProfileDetails,
        getUserAppWithStatus,
        userDetails,
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const {
        setDashboardDetails
    } = useContext(DashboardContext) as DashboardDetailPayload

    const { showSnackbar } = useSnackbar();
    const { stateOptions, getStateOptions } = useStateOptions();
    const isBelow1200 = useIsBelow1200();
    const navigate = useNavigate()
    const recaptchaRef = useRef<ReCAPTCHA | null>(null);

    const [backToLogin, setBackToLogin] = useState<boolean>(false)
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [registeredSiteDetails, setRegisteredSiteDetails] = useState<RegisteredSitesResponse>()
    const [searchParams] = useSearchParams();

    const [errors, setErrors] = useState({
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
        firstName: "",
        lastName: "",
        agencyName: "",
        contact: "",
        stateID: "",
        howYouFindUs: "",
    });

    useEffect(() => {
        getStateOptions()
    }, [])

    useEffect(() => {
        const fetchData = async () => {
            const tokenData = searchParams?.get('token')

            if (searchParams.get('token') && tokenData) {
                const payload: MacSsoVerifyUserPayloadModel = { token: tokenData, flag: false }
                const response = await agent.macssoVerifyUserApi.post(payload)

                if (response?.status) {
                    setFlagLoader(false)
                    if (response?.data?.isUserExist) {
                        navigate("/dashboard")
                        await initializeAuth()
                    }
                    else {
                        const userDetails = response?.data?.user;
                        setRegisterUserProfileDetails({
                            ...registerUserProfileDetails,
                            email: userDetails.email,
                            firstName: userDetails.firstName,
                            lastName: userDetails.lastName,
                            contact: userDetails.phone ?? "",
                            agencyName: userDetails.agencyName ?? "",
                            flagUserExist: true,

                        })
                    }
                }
                else {
                    const err = response?.error?.message;
                    showSnackbar(err, 'error')
                    setUserProfileDetails({ ...userProfileDetails, flagLoggedIn: false });
                    navigate("/")
                    setFlagLoader(false)
                }
            }

            const response = await agent?.getRegisteredSitesV2Api.get();
            console.log("response of getRegisteredSitesV2Api", response);
            setFlagLoader(true)
            if (response?.status) {
                const responseData = response?.data?.registeredSites
                if (responseData) {
                    setRegisteredSiteDetails(responseData)
                }
                setFlagLoader(false)
            }
            else {
                const error = response?.data?.error?.message || "Something Went Wrong!"
                showSnackbar(error, "error")
                setFlagLoader(false)
            }
        };
        fetchData();
    }, []);

    const initializeAuth = async () => {
        try {
            setFlagLoader(true);
            const response = await userDetails();
            if (response?.status && response?.data) {
                const userMeResponse = response.data
                setUserProfileDetails({
                    ...userProfileDetails,
                    flagLoggedIn: true,
                    user: response.data.user,
                    accessToken: response.data.accessToken,
                    // apps: response.data.apps
                });
                // if (userMeResponse.apps) {
                //   setDashboardDetails({ apps: userMeResponse.apps });
                // }
                await fetchApps()
                setFlagLoader(false);
            }
            else {
                navigate('/');
                setUserProfileDetails(prevState => ({ ...prevState, flagLoggedIn: false }));
                setFlagLoader(false);
            }
        } catch (error) {
            console.error('Auth initialization error:', error);
            setUserProfileDetails(prevState => ({ ...prevState, flagLoggedIn: false }));
            navigate('/');
            setFlagLoader(false);
        }
    };

    const fetchApps = async () => {
        const response = await getUserAppWithStatus();
        if (response?.status) {
            const responseData = response?.data
            if (responseData?.apps) {
                setDashboardDetails({ apps: responseData.apps });
            }
        }
        else {
            setFlagLoader(false);
            const error = response?.data?.error?.message ? response?.data?.error?.message : "Something Went Wrong!";
            showSnackbar(error, "error")
        }
    }

    const validateForm = () => {
        const newErrors: any = {};

        // Validate username
        if (!registerUserProfileDetails.username) {
            newErrors.username = "Username is required.";
        } else if (registerUserProfileDetails.username.length < 4 || !/^[a-zA-Z0-9]+$/.test(registerUserProfileDetails.username)) {
            newErrors.username = "Username must be at least 4 characters long and alphanumeric.";
        }

        // Validate email
        if (!registerUserProfileDetails.email) {
            newErrors.email = "Email address is required.";
        } else if (!/\S+@\S+\.\S+/.test(registerUserProfileDetails.email)) {
            newErrors.email = "Please enter a valid email address.";
        }

        // Validate password
        if (!registerUserProfileDetails.flagUserExist) {
            if (!registerUserProfileDetails.password) {
                newErrors.password = "Password is required.";
            }
            else if (registerUserProfileDetails.password.length < 8) {
                newErrors.password = "Password must be at least 8 characters long.";
            }
            else {
                const password = registerUserProfileDetails.password;
                const minLength = 8;
                const hasLowerCase = /[a-z]/.test(password);
                const hasUpperCase = /[A-Z]/.test(password);
                const hasDigit = /\d/.test(password);
                const hasSpecialChar = /[^a-zA-Z0-9\s]/.test(password);

                if (!hasLowerCase) {
                    newErrors.password = "Password must contain at least one lowercase letter.";
                } else if (!hasUpperCase) {
                    newErrors.password = "Password must contain at least one uppercase letter.";
                } else if (!hasDigit) {
                    newErrors.password = "Password must contain at least one digit.";
                } else if (!hasSpecialChar) {
                    newErrors.password = "Password must contain at least one special character.";
                } else if (password.length < minLength) {
                    newErrors.password = "Password must be at least 8 characters long.";
                }
            }
            // Validate confirm password
            if (registerUserProfileDetails.confirmPassword !== registerUserProfileDetails.password) {
                newErrors.confirmPassword = "Confirm password must match the password.";
            }
        }

        // Validate first name
        if (!registerUserProfileDetails.firstName) {
            newErrors.firstName = "First name is required.";
        }

        // Validate last name
        if (!registerUserProfileDetails.lastName) {
            newErrors.lastName = "Last name is required.";
        }

        // Validate agency name
        if (!registerUserProfileDetails.agencyName) {
            newErrors.agencyName = "Agency name is required.";
        }

        // Validate contact number
        // if (!registerUserProfileDetails.contact || registerUserProfileDetails.contact.length < 10) {
        //     newErrors.contact = "Phone number must be at least 10 digits.";
        // }
        // else {
        //     const contactRegex = /^\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
        //     if (!contactRegex.test(registerUserProfileDetails.contact)) {
        //         newErrors.contact = "Please enter valid phone no.";
        //     }
        // }

        // Validate state ID
        if (!registerUserProfileDetails.stateID) {
            newErrors.stateID = "Please select a valid state.";
        }

        // Validate how did you find us
        if (!registerUserProfileDetails.howYouFindUs) {
            newErrors.howYouFindUs = "Please let us know how you found us.";
        }

        return newErrors;
    };

    const handleCreateUser = async () => {
        const newErrors = validateForm();
        setErrors(newErrors);

        // If there are errors, stop submission
        if (Object.values(newErrors).some((error) => error !== "")) {
            return;
        }

        // Utility to safely extract domain
        const getDomainWithoutProtocolAndWWW = (url: string): string => {
            try {
                const parsedUrl = new URL(url.includes("http") ? url : `https://${url}`);
                return parsedUrl.hostname.replace(/^www\./, "").toLowerCase();
            }
            catch {
                return "";
            }
        };

        // Extract and normalize referrer domain
        const referrerDomain = getDomainWithoutProtocolAndWWW(document?.referrer || "");
        const matchedSite = registeredSiteDetails?.registeredSites?.find(site => {
            const siteDomain = getDomainWithoutProtocolAndWWW(site?.registeredSitesDomainUrl || "");
            return referrerDomain && siteDomain && referrerDomain?.includes(siteDomain);
        });
        const matchedRegisteredSiteId = matchedSite?.registeredSiteId ?? 1;

        try {
            // Create the payload from the form data
            let payload: UserRegistrationPayloadModel = {
                username: registerUserProfileDetails.username,
                password: registerUserProfileDetails.password,
                confirmPassword: registerUserProfileDetails.confirmPassword,
                firstName: registerUserProfileDetails.firstName,
                lastName: registerUserProfileDetails.lastName,
                email: registerUserProfileDetails.email,
                agencyName: registerUserProfileDetails.agencyName,
                contact: registerUserProfileDetails.contact,
                addressLine1: registerUserProfileDetails.addressLine1,
                addressLine2: registerUserProfileDetails.addressLine2,
                city: registerUserProfileDetails.city,
                zipcode: registerUserProfileDetails.zipcode,
                stateID: registerUserProfileDetails.stateID,
                howYouFindUs: registerUserProfileDetails.howYouFindUs,
                affiliatedBA: registerUserProfileDetails.affiliatedBA,
                affiliatedBrooklight: registerUserProfileDetails.affiliatedBrooklight,
                reCaptchaToken: registerUserProfileDetails.reCaptchaToken,
                registerIn: matchedRegisteredSiteId
            };
            setFlagLoader(true)
            const response = await agent.userRegistrationAPI.post(payload);
            const successMessage = response?.message ? response?.message : "User Created Successfully!";
            const errorMessage = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
            if (response.status) {
                // showSnackbar(successMessage, 'success')
                recaptchaRef.current?.reset();
                setFlagLoader(false)
                setBackToLogin(true)
                setTimeout(() => {
                    navigate("/login")
                }, 5000);
            }
            else {
                console.log("Error in response", response);
                setFlagLoader(false)
                recaptchaRef.current?.reset();
                showSnackbar(errorMessage, 'error')
            }
        }
        catch (error) {
            setFlagLoader(false)
            console.error("Error during user registration", error);
            showSnackbar("Something Went Wrong!", 'error')
            recaptchaRef.current?.reset();
        }
        // setRegisterUserProfileDetails({
        //     username: "",
        //     password: "",
        //     confirmPassword: "",
        //     firstName: "",
        //     lastName: "",
        //     email: "",
        //     agencyName: "",
        //     contact: "",
        //     addressLine1: "",
        //     addressLine2: "",
        //     city: "",
        //     zipcode: "",
        //     stateID: null,
        //     howYouFindUs: "",
        //     affiliatedBA: 0,
        //     affiliatedBrooklight: 0,
        //     reCaptchaToken: "",
        // })
    };

    const handleBlur = (field: string) => {
        const newErrors = validateForm();
        setErrors({
            ...errors,
            [field]: newErrors[field] || "",
        });
    };


    // const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, affiliation: string) => {
    //     setRegisterUserProfileDetails((prevState) => {
    //         const updatedAffiliations = event.target.checked ? [...prevState.affiliation, affiliation] : prevState.affiliation.filter(item => item !== affiliation);
    //         return { ...prevState, affiliation: updatedAffiliations };
    //     });
    // };


    return (
        <>
            <Grid container>
                <Grid size={{ xs: 12 }} className={`${isBelow1200 ? styles.registrationFormBelowTab : styles.siginupRelative}`}>
                    <Grid container>


                        {isBelow1200 && (
                            <>
                                <Grid size={{ xs: 11 }} className={`${styles.signupMacLogoItem}`}>
                                    <img
                                        src={logo}
                                        alt="Mac Acrylic Logo"
                                        className={styles.signupMacLogo}
                                    />
                                </Grid>
                                <Grid className={`${styles.signupElipsis}`}>
                                    <img src={ellipsis} alt="" />
                                </Grid>
                            </>
                        )}
                        {!isBelow1200 && (
                            <Grid size={{ xs: 12 }} className={`${styles.registrationBannerItem}`}>
                                <Grid container>
                                    <Grid size={{ xl: 11.5, lg: 11.5, md: 11.5, sm: 11.5, xs: 11.5 }} className={`${styles.registerHeadWrapper}`} sx={{ margin: "0 auto" }}>
                                        <Grid container sx={{ justifyContent: 'space-between', alignItems: "center" }}>
                                            <Grid size={{ xl: 5.5, lg: 5.5, md: 5.5, sm: 5.5, xs: 5.5 }} className={`${styles.regBannerLeftItem}`}>
                                                <Grid container>
                                                    <Grid size={{ xs: 12 }} sx={{ margin: "0px 0px 10px" }}>
                                                        <img src={logo} className={`${styles.registerAcrLogo}`} alt="" />
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }} sx={{ margin: "10px 0px 10px" }}>
                                                        <Typography
                                                            component={'span'}
                                                            className={`${globalStyles.gblCF7FAFC} ${globalStyles.globalTextV24}`}
                                                        >
                                                            FREE Sign up for myAdvisor Cloud
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }} sx={{ margin: "10px 0px 10px" }}>
                                                        <Typography
                                                            component={'span'}
                                                            className={`${globalStyles.gblCCFD9E0} ${globalStyles.globalTextV17}`}
                                                            sx={{ fontWeight: "400 !important" }}
                                                        >
                                                            myAdvisor Cloud is the industry's only fully customizable advisor dashboard
                                                            designed to help advisors, and financial professionals increase efficiency and
                                                            grow business. Here will you have 24/7 access to quoting tools, carrier
                                                            contracting, applications, case management data, production information,
                                                            and a wealth of training and marketing materials.
                                                            Complete the form below
                                                            to register for a FREE 60-day trial of myAdvisorCloud. Your request will be
                                                            reviewed by our sales team and you will receive an email notification upon
                                                            approval within 1 business day.
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }} sx={{ margin: "10px 0px 10px" }}>
                                                        <Typography
                                                            component={'span'}
                                                            className={`${globalStyles.gblCF7FAFC} ${globalStyles.globalTextV18}`}
                                                            sx={{ fontWeight: "500 !important" }}
                                                        >
                                                            Thank you and welcome!
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xl: 5, lg: 5, md: 5, sm: 5, xs: 5 }}>
                                                <div className={`${styles.iframeStyles}`}>
                                                    <iframe
                                                        src={videoUrl}
                                                        frameBorder="0"
                                                        allow="autoplay; fullscreen"
                                                        allowFullScreen
                                                        title="Vimeo Video"
                                                        style={{ width: "100%", height: "100%", }}
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                        <Grid size={{ xs: 10.5 }} className={`${styles.regFormMainItem}`}>
                            <Grid container>
                                <Grid size={{ xs: 12 }} sx={{ margin: "0px 0px 30px" }}>
                                    <Grid container>
                                        {isBelow1200 &&
                                            <Grid size={{ xs: 12 }} sx={{ margin: "20px auto" }}>
                                                <Typography
                                                    component={'span'}
                                                    className={`${globalStyles.globalTextV26} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gbl141D2B}`}
                                                >
                                                    FREE Sign up for myAdvisor Cloud
                                                </Typography>
                                            </Grid>
                                        }

                                        <Grid size={{ xs: 12 }} className={`${styles.regFormHeadItem} `}>
                                            <Typography
                                                component={'span'}
                                                className={`${isBelow1200 ? `${globalStyles.gblCWhite} ${globalStyles.globalTextV20}` : `${globalStyles.globalTextV24} ${globalStyles.gbl141D2B}`}`}
                                            >
                                                Account Information
                                            </Typography>
                                        </Grid>

                                        <Divider
                                            className={`${styles.regDivider}`}
                                            sx={{ borderColor: isBelow1200 ? "#ffffff" : "#1A2537B2" }}
                                        />

                                        <Grid size={{ xs: 12 }}>
                                            <Grid container sx={{ gap: '20px 30px' }}>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Grid container>
                                                                <Grid size={10}>
                                                                    <Typography
                                                                        component={'span'}
                                                                        className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                                    >
                                                                        Username <GlobalSymbols symbol="astric" />
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid size={2} sx={{ textAlign: "end" }}>
                                                                    <InfoOutlinedIcon sx={{ fontSize: "20px", color: isBelow1200 ? "white" : "black" }} />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter Name'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                onBlur={() => handleBlur("username")}
                                                                error={Boolean(errors.username)}
                                                                helperText={errors.username}
                                                                value={registerUserProfileDetails.username}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        username: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                E-mail Address <GlobalSymbols symbol="astric" />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter Email'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                onBlur={() => handleBlur("email")}
                                                                error={Boolean(errors.email)}
                                                                helperText={errors.email}
                                                                value={registerUserProfileDetails.email}
                                                                disabled={registerUserProfileDetails.flagUserExist ? true : false}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        email: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                {registerUserProfileDetails.flagUserExist ? (<></>) :
                                                    (<>
                                                        <Grid className={`${styles.regFieldsMainItem}`}>
                                                            <Grid container>
                                                                <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                                    <Typography
                                                                        component={'span'}
                                                                        className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                                    >
                                                                        Create Password <GlobalSymbols symbol="astric" />
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid size={{ xs: 12 }}>
                                                                    <GlobalTextfield
                                                                        fullWidth
                                                                        placeholder='Enter Password'
                                                                        stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                        size='small'
                                                                        autoComplete='off'
                                                                        type={showPassword ? 'text' : 'password'}
                                                                        onBlur={() => handleBlur("password")}
                                                                        error={Boolean(errors.password)}
                                                                        helperText={errors.password}
                                                                        value={registerUserProfileDetails.password}
                                                                        onChange={(e) => {
                                                                            setRegisterUserProfileDetails({
                                                                                ...registerUserProfileDetails,
                                                                                password: e.target.value
                                                                            })
                                                                        }}
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position="start" sx={{ margin: '0px', borderLeft: "1px solid #CFD9E0" }}>
                                                                                    <IconButton
                                                                                        edge="start"
                                                                                        size='small'
                                                                                        onClick={() => { setShowPassword(!showPassword) }}
                                                                                        sx={{
                                                                                            margin: "0px 10px 0px 5px",
                                                                                        }}
                                                                                    >
                                                                                        {showPassword ?
                                                                                            <VisibilityOff
                                                                                                sx={{ fontSize: "23px", color: "#718096" }}
                                                                                            /> :
                                                                                            <Visibility
                                                                                                sx={{ fontSize: "23px", color: "#718096" }}
                                                                                            />
                                                                                        }
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid className={`${styles.regFieldsMainItem}`}>
                                                            <Grid container>
                                                                <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                                    <Typography
                                                                        component={'span'}
                                                                        className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                                    >
                                                                        Confirm Password <GlobalSymbols symbol="astric" />
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid size={{ xs: 12 }}>
                                                                    <GlobalTextfield
                                                                        fullWidth
                                                                        placeholder='Enter Password'
                                                                        stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                        size='small'
                                                                        autoComplete='off'
                                                                        type={showConfirmPassword ? 'text' : 'password'}
                                                                        onBlur={() => handleBlur("confirmPassword")}
                                                                        error={Boolean(errors.confirmPassword)}
                                                                        helperText={errors.confirmPassword}
                                                                        value={registerUserProfileDetails.confirmPassword}
                                                                        onChange={(e) => {
                                                                            setRegisterUserProfileDetails({
                                                                                ...registerUserProfileDetails,
                                                                                confirmPassword: e.target.value
                                                                            })
                                                                        }}
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position="start" sx={{ margin: '0px', borderLeft: "1px solid #CFD9E0" }}>
                                                                                    <IconButton
                                                                                        edge="start"
                                                                                        size='small'
                                                                                        onClick={() => { setShowConfirmPassword(!showConfirmPassword) }}
                                                                                        sx={{
                                                                                            margin: "0px 10px 0px 5px",
                                                                                        }}
                                                                                    >
                                                                                        {showConfirmPassword ?
                                                                                            <VisibilityOff
                                                                                                sx={{ fontSize: "23px", color: "#718096" }}
                                                                                            /> :
                                                                                            <Visibility
                                                                                                sx={{ fontSize: "23px", color: "#718096" }}
                                                                                            />
                                                                                        }
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </>)
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid size={{ xs: 12 }} sx={{ margin: "0px 0px 30px" }}>
                                    <Grid container>
                                        <Grid size={{ xs: 12 }} className={`${styles.regFormHeadItem} `}>
                                            <Typography
                                                component={'span'}
                                                className={`${isBelow1200 ? `${globalStyles.gblCWhite} ${globalStyles.globalTextV20}` : `${globalStyles.globalTextV24} ${globalStyles.gbl141D2B}`}`}
                                            >
                                                Your Details
                                            </Typography>
                                        </Grid>

                                        <Divider
                                            className={`${styles.regDivider}`}
                                            sx={{ borderColor: isBelow1200 ? "#ffffff" : "#1A2537B2" }}
                                        />

                                        <Grid size={{ xs: 12 }}>
                                            <Grid container sx={{ gap: '20px 30px' }}>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                First Name <GlobalSymbols symbol="astric" />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter First Name'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                onBlur={() => handleBlur("firstName")}
                                                                error={Boolean(errors.firstName)}
                                                                helperText={errors.firstName}
                                                                disabled={(registerUserProfileDetails.flagUserExist && registerUserProfileDetails.firstName !== "") ? true : false}
                                                                value={registerUserProfileDetails.firstName}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        firstName: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                Last Name <GlobalSymbols symbol="astric" />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter Last Name'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                onBlur={() => handleBlur("lastName")}
                                                                error={Boolean(errors.lastName)}
                                                                helperText={errors.lastName}
                                                                disabled={(registerUserProfileDetails.flagUserExist && registerUserProfileDetails.lastName !== "") ? true : false}
                                                                value={registerUserProfileDetails.lastName}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        lastName: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                Agency Name <GlobalSymbols symbol="astric" />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter Agency Name'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                onBlur={() => handleBlur("agencyName")}
                                                                error={Boolean(errors.agencyName)}
                                                                helperText={errors.agencyName}
                                                                value={registerUserProfileDetails.agencyName}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        agencyName: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                Phone <GlobalSymbols symbol="astric" />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalPhoneInput country='us'
                                                                onBlur={() => handleBlur("contact")}
                                                                error={Boolean(errors.contact)}
                                                                helperText={errors.contact}
                                                                disabled={(registerUserProfileDetails.flagUserExist && registerUserProfileDetails.contact !== "") ? true : false}
                                                                value={registerUserProfileDetails.contact}
                                                                onChange={(contact) => {
                                                                    // if (contact.length > 11) return
                                                                    // const last10Digits = contact.toString().slice(-10);
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        contact: contact
                                                                    })
                                                                }
                                                                }
                                                            />
                                                            {/* <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter Phone'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                onBlur={() => handleBlur("contact")}
                                                                error={Boolean(errors.contact)}
                                                                helperText={errors.contact}
                                                                value={registerUserProfileDetails.contact}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        contact: e.target.value
                                                                    })
                                                                }}
                                                            /> */}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                Address Line 1
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter Address'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                multiline
                                                                rows={3}
                                                                value={registerUserProfileDetails.addressLine1}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        addressLine1: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                Address Line 2
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter Address'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                multiline
                                                                rows={3}
                                                                value={registerUserProfileDetails.addressLine2}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        addressLine2: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                Zipcode
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter Zipcode'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                value={registerUserProfileDetails.zipcode}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        zipcode: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                City
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter City'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                value={registerUserProfileDetails.city}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        city: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                Select State <GlobalSymbols symbol="astric" />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalAutocomplate
                                                                size='small'
                                                                fullWidth
                                                                className={`${styles.regAutocommplate}`}
                                                                options={stateOptions}
                                                                getOptionLabel={(options: StateOptionsInterface) => options.state_name}
                                                                placeholder='Select State'
                                                                onBlur={() => handleBlur("stateID")}  // Trigger validation when the user clicks out
                                                                error={Boolean(errors.stateID)}  // Show error if state is not selected
                                                                helperText={errors.stateID}  // Display error message
                                                                value={stateOptions?.find(option => option.state_id == registerUserProfileDetails.stateID) || null}
                                                                onChange={(event: any, newValue: any) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        stateID: newValue ? newValue.state_id : null,
                                                                    });
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        className={styles.regAutocommplateField}
                                                                        {...params}
                                                                        variant="outlined"
                                                                        placeholder='Select State'
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid size={{ xs: 12 }} >
                                    <Grid container>
                                        <Grid size={{ xs: 12 }} className={`${styles.regFormHeadItem} `}>
                                            <Typography
                                                component={'span'}
                                                className={`${isBelow1200 ? `${globalStyles.gblCWhite} ${globalStyles.globalTextV20}` : `${globalStyles.globalTextV24} ${globalStyles.gbl141D2B}`}`}
                                            >
                                                Other Details
                                            </Typography>
                                        </Grid>

                                        <Divider
                                            className={`${styles.regDivider}`}
                                            sx={{ borderColor: isBelow1200 ? "#ffffff" : "#1A2537B2" }}
                                        />

                                        <Grid size={{ xs: 12 }}>
                                            <Grid container sx={{ gap: '20px 30px' }}>
                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <Grid container>
                                                        <Grid size={{ xs: 12 }} className={`${styles.regFieldHeadItem}`}>
                                                            <Typography
                                                                component={'span'}
                                                                className={`${globalStyles.globalTextV16} ${isBelow1200 ? globalStyles.gblCWhite : globalStyles.gblC171923}`}
                                                            >
                                                                How did you find us? <GlobalSymbols symbol="astric" />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12 }}>
                                                            <GlobalTextfield
                                                                fullWidth
                                                                placeholder='Enter Address'
                                                                stylingClassName={`${globalStyles.globalFieldStyles}`}
                                                                size='small'
                                                                autoComplete='off'
                                                                multiline
                                                                rows={3}
                                                                onBlur={() => handleBlur("howYouFindUs")}
                                                                error={Boolean(errors.howYouFindUs)}
                                                                helperText={errors.howYouFindUs}
                                                                value={registerUserProfileDetails.howYouFindUs}
                                                                onChange={(e) => {
                                                                    setRegisterUserProfileDetails({
                                                                        ...registerUserProfileDetails,
                                                                        howYouFindUs: e.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid className={`${styles.regFieldsMainItem}`}>
                                                    <FormLabel
                                                        component="legend"
                                                        sx={{ color: isBelow1200 ? "#ffffff" : "#141D2B", fontSize: "16px", fontWeight: '700', ml: "7px" }}
                                                    >Are you affiliated with</FormLabel>
                                                    <FormGroup>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    sx={{ padding: "3px" }}
                                                                    checked={registerUserProfileDetails.affiliatedBA === 1} // Check if selected
                                                                    onChange={(e) => {
                                                                        const checked = e.target.checked;
                                                                        setRegisterUserProfileDetails((prev) => ({
                                                                            ...prev,
                                                                            affiliatedBA: checked ? 1 : 0,
                                                                            // If user checks either of the two, unselect None
                                                                            selectedNone: checked ? false : prev.selectedNone
                                                                        }));
                                                                    }}
                                                                />
                                                            }
                                                            sx={{ marginLeft: 0, fontSize: "13px", }}
                                                            label="Brokers Alliance"
                                                            labelPlacement='end'
                                                            className={styles.regCheckbox}
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    sx={{ padding: "3px" }}
                                                                    checked={registerUserProfileDetails.affiliatedBrooklight === 1} // Check if selected
                                                                    onChange={(e) => {
                                                                        const checked = e.target.checked;
                                                                        setRegisterUserProfileDetails((prev) => ({
                                                                            ...prev,
                                                                            affiliatedBrooklight: checked ? 1 : 0,
                                                                            // If user checks either of the two, unselect None
                                                                            selectedNone: checked ? false : prev.selectedNone
                                                                        }));
                                                                    }}
                                                                />
                                                            }
                                                            sx={{ marginLeft: 0, fontSize: "13px" }}
                                                            label="Brooklight Place Securities"
                                                            labelPlacement='end'
                                                            className={styles.regCheckbox}
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    sx={{ padding: "3px" }}
                                                                    checked={registerUserProfileDetails.selectedNone}
                                                                    onChange={(e) => {
                                                                        const checked = e.target.checked;
                                                                        setRegisterUserProfileDetails((prev) => ({
                                                                            ...prev,
                                                                            affiliatedBA: 0,
                                                                            affiliatedBrooklight: 0,
                                                                            selectedNone: checked,
                                                                        }));
                                                                    }}
                                                                />
                                                            }
                                                            sx={{ marginLeft: 0, fontSize: "13px" }}
                                                            label="None"
                                                            labelPlacement='end'
                                                            className={styles.regCheckbox}
                                                        />
                                                    </FormGroup>
                                                </Grid>

                                                <Grid size={{ xs: 12 }}>
                                                    <ReCAPTCHA
                                                        ref={recaptchaRef}
                                                        className={`${styles.gRecaptcha}`}
                                                        sitekey="6LfyVJ0UAAAAAJOnWbofCE79xHEH6Rhk4mwEX00q"
                                                        onChange={(token: string | null) => {
                                                            setRegisterUserProfileDetails({
                                                                ...registerUserProfileDetails,
                                                                reCaptchaToken: token
                                                            });
                                                        }}
                                                    />
                                                </Grid>

                                                {backToLogin && (
                                                    <Grid size={{ xs: 12 }} sx={{ textAlign: "center", margin: "10px 0px 0px" }}>
                                                        <Grid container sx={{ justifyContent: "center", gap: "10px" }}>
                                                            <Grid sx={{
                                                                padding: "10px 15px", borderRadius: "5px", background: "#93FF001A", border: "1px solid #1C4532"
                                                            }}>
                                                                Registration successful. Please verify your email address to complete the login process.
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                                <Grid size={{ xs: 12 }} sx={{ textAlign: "center", margin: "10px 0px 0px", display: "flex", justifyContent: "center", gap: "20px" }}>
                                                    <GlobalButton
                                                        value={"Back to Login Page"}
                                                        startIcon={<ArrowBack />}
                                                        size='large'
                                                        className={`${styles.backToLoginBtn}`}
                                                        onClick={() => { navigate('/login') }}
                                                    />
                                                    {!backToLogin && (
                                                        <GlobalButton
                                                            value="Register"
                                                            size="large"
                                                            className={styles.registerBtn}
                                                            onClick={handleCreateUser}
                                                        />
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}

export default Registration